import { Block, UiDiv } from '@webfox-sc/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useCheckitemgrouptypeOptions } from '../../../app/entityHooks/useCheckitemgrouptypeOptions';
import IconCheck from '../../../assets/icons-v2/IconCheck';
import IconClose from '../../../assets/icons-v2/IconClose';
import Button from '../../atoms-v2/Button';
import FormElementLabel from '../../atoms-v2/FormElementLabel';
import CustomReactSelect from '../../CustomReactSelect';

type QMAdminConfigCheckitemgroupCreateFormProps = {
  onClickSave?: (name: number) => void;
  onClickCancel?: React.MouseEventHandler<HTMLButtonElement>;
};

const QMAdminConfigCheckitemgroupCreateForm: React.FC<QMAdminConfigCheckitemgroupCreateFormProps> = ({
  onClickSave,
  onClickCancel,
}) => {
  const { t } = useTranslation();
  const { checkitemgrouptypeOptions } = useCheckitemgrouptypeOptions();
  const [checkitemgrouptype, setCheckitemgrouptype] = useState<number | null>(null);

  const handleOnClickSave = () => {
    if (!!onClickSave && !!checkitemgrouptype) {
      onClickSave(checkitemgrouptype);
    }
    setCheckitemgrouptype(null);
  };

  return (
    <Block>
      <FormElementLabel>{t('common.fields.name')} *</FormElementLabel>
      <UiDiv>
        <CustomReactSelect
          options={checkitemgrouptypeOptions}
          selectedValue={checkitemgrouptype}
          isSearchable
          onChangeValue={setCheckitemgrouptype}
          placeholder="Auswählen ..."
        />
      </UiDiv>
      <UiDiv display="flex" columnGap="xs" justifyContent="space-between" paddingTop="xs">
        <UiDiv display="flex" columnGap="xs">
          <Button type="submit" icon={IconCheck} disabled={!checkitemgrouptype} onClick={handleOnClickSave}>
            {t('common.actions.save')}
          </Button>
          <Button variant="secondary" icon={IconClose} onClick={onClickCancel}>
            {t('common.actions.cancel')}
          </Button>
        </UiDiv>
      </UiDiv>
    </Block>
  );
};

export default QMAdminConfigCheckitemgroupCreateForm;
